import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

export const BrandMark = ({ className = "w-5 h-5", color = "#D97706" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path d="M50 8 L57 38 L88 28 L66 50 L88 72 L57 62 L50 92 L43 62 L12 72 L34 50 L12 28 L43 38 Z" fill="none" stroke={color} strokeWidth="4" strokeLinejoin="round" />
    <circle cx="50" cy="50" r="6" fill={color} />
  </svg>
);

export const Logo = ({ light = false, to = "/", testId = "brand-logo" }) => {
  const { settings } = useSettings();
  const name = settings?.short_name || "KAUR";
  const sub = settings?.business_name?.replace(/^kaur\s*/i, "") || "Cleaning Services";
  return (
    <Link to={to} data-testid={testId} className="inline-flex items-center gap-2.5 group min-w-0 shrink">
      {settings?.logo_url ? (
        <img src={settings.logo_url} alt={settings.business_name} className="h-10 w-auto" />
      ) : (
        <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full border ${light ? "border-white/30" : "border-[#E5E2DA] bg-white"}`}>
          <BrandMark />
        </span>
      )}
      <span className="leading-none min-w-0">
        <span className={`block font-display text-xl font-semibold tracking-[0.12em] ${light ? "text-white" : "text-[var(--kc-text)]"}`}>{name}</span>
        <span className={`block text-[10px] font-semibold tracking-[0.22em] uppercase truncate ${light ? "text-white/70" : "text-[#5A606A]"}`}>{sub}</span>
      </span>
    </Link>
  );
};
